import * as _ from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import DateTimePicker from '@nkr/components/date-time-picker';
import { IManualInvoiceLineItem, IManualInvoiceLineItemLookup } from '@nkr/store/billing/actions-admin-line-items';
import { OrganType } from '@nkr/enums/organ-type';

type LineItemProps = {
    invoiceDate: string,
    lookup: IManualInvoiceLineItemLookup,
    addLineItem: (lineItem: IManualInvoiceLineItem) => void
}

interface IState {
    id: number,
    userId: number,
    username: string,
    centerId: number,
    centerAlias: string,
    date: string,
    description: string,
    applyTo: number,
    applyToDescription: string,
    isCredit: boolean,
    organType: OrganType,
    amount: number
}

class ManualLineItemAddFormRow extends React.Component<LineItemProps, IState> {
    readonly state: IState = {
        id: 0,
        userId: 0,
        username: '[you]',
        centerId: 0,
        centerAlias: '',
        date: moment(this.props.invoiceDate).format("YYYY-MM-DD"),
        description: '',
        applyTo: 0,
        applyToDescription: '',
        isCredit: false,
        organType: null,
        amount: 0
    }

    onFieldChange = (e) => {
        let { name, value } = e.currentTarget;

        let state = { ...this.state };
        state[name] = value;

        this.setState(state);
    }

    onDateChanged = (property: string, selectedDate: moment.Moment) => {
        let update = { ...this.state }
        update[property] = selectedDate.format("YYYY-MM-DD");
        this.setState(update);
    }

    addLineItem = () => {
        let lineItem = { ...this.state } as IManualInvoiceLineItem;
        this.props.addLineItem(lineItem);
    }

    render = () => {
        return (
            <tfoot style={{ overflow: "visible" }}>
                <tr>
                    <td style={{ width: "5%" }}>{this.state.username}</td>
                    <td style={{ width: "9%" }}>
                        <select
                            name="centerId"
                            className="form-control"
                            onChange={this.onFieldChange.bind(this)}
                        >
                            <option value="">Select</option>
                            {this.props.lookup.centers.map(item =>
                                <option
                                    value={item.value}
                                    selected={this.state.centerId.toString() == item.value}
                                >
                                    {item.label}
                                </option>
                            )}
                        </select>
                    </td>
                    <td style={{ width: "12%" }}>
                        <div
                            style={{
                                transform: "scaleY(1.25)",
                                transformOrigin: "top",
                                width: "100%"
                            }}
                        >
                            <DateTimePicker
                                property="date"
                                dateFormat="MM/DD/YYYY"
                                currentValue={this.state.date}
                                onValueChanged={this.onDateChanged.bind(this)}
                                showTime={false}
                            />
                        </div>
                    </td>
                    <td style={{ width: "7%" }}>
                        <select
                            name="organType"
                            className="form-control"
                            onChange={this.onFieldChange.bind(this)}
                        >
                            <option value={OrganType.Kidney} selected={this.state.organType == OrganType.Kidney}>Kidney</option>
                            <option value={OrganType.Liver} selected={this.state.organType == OrganType.Liver}>Liver</option>
                        </select>
                    </td>

                    <td style={{ width: "30%" }}>
                        <input
                            name="description"
                            className="form-control"
                            type="text"
                            value={this.state.description}
                            onChange={this.onFieldChange.bind(this)}
                        />
                    </td>

                    <td style={{ width: "25%" }}>
                        <select
                            name="applyTo"
                            className="form-control"
                            onChange={this.onFieldChange.bind(this)}
                        >
                            <option value="">Select</option>
                            {this.props.lookup.invoiceLineItemTypes.map(item =>
                                <option
                                    value={item.value}
                                    selected={this.state.applyTo.toString() === item.value}
                                >
                                    {item.label}
                                </option>
                            )}
                        </select>
                    </td>

                    <td style={{ width: "7%" }}>
                        <select
                            name="isCredit"
                            className="form-control"
                            onChange={this.onFieldChange.bind(this)}
                        >
                            <option value="false" selected={this.state.isCredit == false}>Debit</option>
                            <option value="true" selected={this.state.isCredit == true}>Credit</option>
                        </select>
                    </td>

                    <td style={{ width: "7%" }}>
                        <input
                            name="amount"
                            className="form-control"
                            type="number"
                            value={this.state.amount}
                            onChange={this.onFieldChange.bind(this)}
                        />
                    </td>

                    <td style={{ width: "5%" }}>
                        <button className="btn btn-primary" onClick={() => this.addLineItem()}>add</button>
                    </td>
                </tr>
            </tfoot>

        );
    }
}

export default ManualLineItemAddFormRow;